import { Injectable, inject } from '@angular/core';
import { SessionService } from '@yukawa/chain-main-angular-session';
import { TranslocoService } from '@jsverse/transloco';
import { lastValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AppInitializerService {
  private _sessionService = inject(SessionService);
  private _translocoService = inject(TranslocoService);


  async initialize(): Promise<void> {
    // Merge translations first
    await this.mergeTranslations((lang: string) => `yukawa/${lang}`);
    await this.mergeTranslations((lang: string) => lang);

    // Restore session before routing begins
    await this._sessionService.restore();
  }

  private async mergeTranslations(transformLocation: (lang: string) => string): Promise<void> {
    await Promise.all(this._translocoService.getAvailableLangs().map(async (lang) => {
      lang = typeof lang === 'string' ? lang : lang.id;
      this._translocoService.setTranslation(
        await lastValueFrom(this._translocoService.load(transformLocation(lang))),
        lang, {
        merge: true,
      },
      );
    }));
  }
}
